import con from '../../../../connection';
var path = '/reset';
var reset = function (url) { return function () { return ({
    post: function (param) {
        return con.post(url + path, param);
    },
}); }; };
export default reset;
